import mainPageEn from "@locales/en/main-page.json";
import layoutEn from "@locales/en/layout.json";
import modalsEn from "@locales/en/modals.json";
import apiResponseEn from "@locales/en/api-response.json";
import commonEn from "@locales/en/common.json";

export const resources = {
  en: {
    mainPage: mainPageEn,
    layout: layoutEn,
    modals: modalsEn,
    apiResponse: apiResponseEn,
    common: commonEn
  }
};
